<div>
  <!-- Button Group -->
  @if (options.buttons.display) {
    <div class="trial-insights-table-button-container">
      @for (button of options.buttons.data; track button) {
        <button
          class="trial-insights-table-button"
          [ngClass]="button.key === selectedKey ? 'btn--primary' : 'btn--secondary'"
          (click)="select(button.key)"
        >
          {{ button.value }}
        </button>
      }
    </div>
  }

  <!-- Table Header -->
  @if (options.header.display) {
    <div class="trial-insights-table-header-container">
      <span class="trial-insights-table-header flex-grow">{{ headers[0] }}</span>
      <div class="sort" (click)="sort()">
        <span class="trial-insights-table-header select-none">{{ headers[1] }}</span>

        <!-- Toggle sort direction -->
        @if (!isLoadingRemaining) {
          <div class="ml-1 flex">
            @if (sortOrder === 'DESC') {
              <span class="trial-insights-table-header sorting-icon">&darr;</span>
            }
            @if (sortOrder === 'ASC') {
              <span class="trial-insights-table-header sorting-icon">&uarr;</span>
            }
          </div>
        }

        <!-- Toggle spinner -->
        @if (isLoadingRemaining) {
          <div class="trial-insights-table-spinner-container">
            <div class="dot-flashing"></div>
          </div>
        }
      </div>
    </div>
  }

  <!-- Table -->
  <div class="trial-insights-table-row-container">
    <!-- Table Row -->
    @for (row of rowData; track row) {
      <div class="trial-insights-table-row" [class.compact]="options.rowData.compact">
        <!-- Color Icon -->
        @if (row.color) {
          <div
            class="trial-insights-table-row-icon"
            [style.background-color]="row.color ? row.color : ''"
          ></div>
        }

        <!-- Left side -->
        <div class="trial-insights-table-row-text left">
          <span class="header">{{ row.leftHeader }}</span>
          <span class="subheader">{{ row.leftSubheader }}</span>
        </div>

        <!-- Right Side -->
        <div class="trial-insights-table-row-text right">
          <span class="header">{{ row.rightHeader }}</span>
          <span class="subheader">{{ row.rightSubheader }}</span>
        </div>
      </div>
    }
  </div>

  <!-- Link -->
  @if (options.link.display) {
    <div class="trial-insights-table-link-container">
      <a [routerLink]="options.link.url" class="btn--hyperlink">{{ options.link.value }}</a>
    </div>
  }
</div>
